import {
    Box,
    Button,
    Link,
    Popover,
    SpaceBetween,
} from '@amzn/awsui-components-react';
import React from 'react';
import JSONPretty from 'react-json-pretty';
import { RebootEvent } from '../../../../types';

interface Props {
    event: RebootEvent;
    processedDetails: any;
    children: React.ReactNode;
}

const DetailPopover: React.FC<Props> = ({
    event,
    processedDetails,
    children
}) => {

    if (!event.details) return <>{children}</>;

    const copyToClipboard = () => {
        try {
            navigator.clipboard.writeText(JSON.stringify(processedDetails, null, 2))
        } catch (error) {
            console.error(error);
            navigator.clipboard.writeText(event.details || '')
        }
    };

    const region = event.execution_arn.split(':')[3];
    const consoleUrl = `https://console.aws.amazon.com/states/home?region=${region}#/executions/details/${event.execution_arn}`;

    return (
        <Popover
            position="bottom"
            size='large'
            dismissButton={true}
            triggerType="custom"
            content={
                <div style={{
                    overflow: 'auto'
                }}>
                        <SpaceBetween direction='horizontal' size='l' alignItems='center'>
                            <Button
                                iconName="copy"
                                onClick={copyToClipboard}
                            >
                            </Button>
                            <Link external href={consoleUrl}>View in Console</Link>
                        </SpaceBetween>
                    <Box>
                        <JSONPretty data={processedDetails}></JSONPretty>
                    </Box>
                </div>
            }
        >
            {children}
        </Popover>
    );
};

export default DetailPopover;